/* The blog's behaviour. Concatenated after assets/js/lib/*.js, header-layers.js,
   motion.js and lightbox.js into assets/built/site.js by gulp. No jQuery. */
(function () {
    'use strict';

    // The site's two-layer header follows the dark zones under it (assets/js/header-layers.js).
    var header = document.querySelector('[data-cy-header]');
    if (header && typeof cyHeaderLayers === 'object') {
        var darkLayer = header.querySelector('[data-cy-layer="dark"]');
        var lightLayer = header.querySelector('[data-cy-layer="light"]');
        if (darkLayer && lightLayer) {
            cyHeaderLayers.mount(header, darkLayer, lightLayer);
        }
    }

    // The arrivals, the magnetic buttons, an article's back to top pill and, where there are no scroll timelines, its
    // reading line (assets/js/motion.js), each off where it should be.
    if (typeof cyMotion === 'object') {
        cyMotion.mount(window, document);
    }

    // The site's phone menu: the round toggle beside the call button opens the list under the header.
    var toggle = document.querySelector('[data-cy-menu]');
    var nav = document.getElementById('mobile-nav');
    if (toggle && nav) {
        var setOpen = function (open) {
            nav.hidden = !open;
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        };
        toggle.addEventListener('click', function () {
            setOpen(nav.hidden);
        });
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && !nav.hidden) {
                setOpen(false);
                toggle.focus();
            }
        });
        document.addEventListener('click', function (event) {
            if (!nav.hidden && !nav.contains(event.target) && !toggle.contains(event.target)) {
                setOpen(false);
            }
        });
    }

    // A post tagged #q-CODE sends every WhatsApp button on the page through
    // caryaar.com/q/CODE, the placement's own door (message, code, scan ledger),
    // exactly as a printed banner's QR does. Ghost stores the internal tag as
    // the slug hash-q-code, and adds -2, -3 when a tag NAME is reused, so
    // hash-q-k3f7-2 is still placement K3F7.
    var box = document.querySelector('[data-cy-wa]');
    if (box) {
        var tags = (box.getAttribute('data-tags') || '').split(/\s+/);
        for (var i = 0; i < tags.length; i += 1) {
            var match = /^hash-q-([0-9a-hjkmnp-tv-z]{4,8})(?:-\d+)?$/i.exec(tags[i]);
            if (!match) {
                continue;
            }
            var href = 'https://caryaar.com/q/' + match[1].toUpperCase();
            var links = document.querySelectorAll('[data-cy-wa-link]');
            for (var j = 0; j < links.length; j += 1) {
                links[j].setAttribute('href', href);
            }
            break;
        }
    }

    // Casper's lightbox for images and galleries in the article.
    if (typeof lightbox === 'function') {
        lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');
    }
})();
